import {
  LoadSkillApplicationsRequestAction,
  LoadSkillApplicationsSuccessAction,
  LoadSkillApplicationsErrorAction,
  ProcessActionRequestAction,
  ProcessActionErrorAction,
  ProcessActionSuccessAction,
} from './actions.d';
import actionsTypes from './actionTypes';
import { ILoadDataRequestPayload, ILoadDataSuccessPayload, IProcessRequestPayload } from './types.d';

const actions = {
  loadSkillApplicationsRequest: <T1, T2>(
    payload: ILoadDataRequestPayload<T1, T2>,
  ): LoadSkillApplicationsRequestAction<T1, T2> => ({
    type: actionsTypes.LOAD_SKILL_APPLICATIONS_REQUEST,
    payload,
  }),

  loadSkillApplicationsSuccess: (payload: ILoadDataSuccessPayload): LoadSkillApplicationsSuccessAction => ({
    type: actionsTypes.LOAD_SKILL_APPLICATIONS_SUCCESS,
    payload,
  }),

  loadSkillApplicationsError: (): LoadSkillApplicationsErrorAction => ({
    type: actionsTypes.LOAD_SKILL_APPLICATIONS_ERROR,
  }),

  processActionRequest: <T1, T2>(payload: IProcessRequestPayload<T1, T2>): ProcessActionRequestAction<T1, T2> => ({
    type: actionsTypes.PROCESS_ACTION_REQUEST,
    payload,
  }),

  processActionSuccess: (): ProcessActionSuccessAction => ({
    type: actionsTypes.PROCESS_ACTION_SUCCESS,
  }),

  processActionError: (): ProcessActionErrorAction => ({
    type: actionsTypes.PROCESS_ACTION_ERROR,
  }),
};

export default actions;
